import React from 'react';
import Sidebar from '../components/Sidebar/Sidebar';
import PostCard from '../components/PostCard/PostCard';
import styles from './HomePage.module.css';
import {useFetchPrePost} from "../hooks/useFetchPost";

const HomePage = () => {
    const {posts, loading, error} = useFetchPrePost();
    if (loading) {
        return <div className={styles.loading}>Загрузка постов...</div>;
    }

    if (error) {
        return (
            <div className={styles.error}>
                Ошибка: {error}
            </div>
        );
    }

    if (!posts) {
        return (
            <div className={styles.notFound}>
                Посты не найдены
            </div>
        );
    }

    return (
            <div className={styles.content}>
                <section className={styles.posts}>
                    <h1 className={styles.pageTitle}>Последние публикации</h1>
                    <div className={styles.postsGrid}>
                        {posts.map(post => (
                            <PostCard
                                key={post.id}
                                id={post.id}
                                title={post.title}
                                date={post.date.split('T')[0]}
                                excerpt={post.excerpt || "Нет краткого описания"}
                                category={post.category.name}
                            />
                        ))}
                    </div>
                </section>
                <div className={styles.sidebarContainer}>
                    <Sidebar/>
                </div>
            </div>
    );
};

export default HomePage;